const Sprite = () => (
    <div className="svg-sprite">
        <svg xmlns="http://www.w3.org/2000/svg">
            <symbol viewBox="0 0 100 100" id="loader">
                <title>loader</title>
                <circle
                    cx="50"
                    cy="50"
                    fill="none"
                    stroke="#e6000f"
                    strokeWidth="8"
                    r="46"
                    strokeDasharray="216.76989309769573 74.25663103256524"
                    transform="rotate(63.9542 50 50)"
                />
            </symbol>
        </svg>
    </div>
)

export default Sprite